//Request

export interface UploadDocRequest {
  PolicyId: number;
  VersionNum: number;
  FormType: string;
  DocTypeName: string;
  FormName?: string;
  FolderType: string;
  FileName: string;
  PdfData: string;
}

//Response

export interface UploadDocResponse {
  Status: string;
  Warnings: [];
  Errors: [];
}
